import cn from 'classnames'
import React from 'react'
import { TabButton } from 'src/components/Tabs/TabButton'

interface SolutionSearchPageTabProps {
  className: string
  id: number
  activeTab: number
  onSelectTab: (activeTab: number) => void
  children?: React.ReactNode
}

export const SolutionSearchPageTab: React.FC<SolutionSearchPageTabProps> = ({
  id,
  activeTab,
  className,
  children,
  onSelectTab,
}) => {
  return (
    <TabButton
      className={cn(activeTab === id ? `md:mr-[0px] mr-[12px]` : `md:mr-[0px] mr-[12px]`, className)}
      isSelected={activeTab === id}
      onClick={() => onSelectTab(id)}
    >
      {children}
    </TabButton>
  )
}
